import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  EXECUTIVE_SUMMARY_MARKET_NAMES,
  prefix,
} from 'components/BusinessToolForm/Sections/ExecutiveSummary/MarketExecSummary/utils/form';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const MarketExecSum: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('executiveSummary.title')}
          badgeText={t('executiveSummary.market.title')}
          section={FOR_INVESTORS_SECTIONS.EXECUTIVE_SUMMARY}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.targetMarket')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET)}
      >
        {/* 1.4.1 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.market.targetMarket"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_MARKET)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.dynamics')}
        aiFieldName={concatWithDot(prefix, EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS)}
      >
        {/* 1.4.2 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.market.dynamics"
          name={concatWithDot(prefix, EXECUTIVE_SUMMARY_MARKET_NAMES.DYNAMICS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.targetAudience')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE)}
      >
        {/* 1.4.3 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.market.targetAudience"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_AUDIENCE)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.sellingChannels')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_CHANNELS)}
      >
        {/* 1.4.4 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.market.sellingChannels"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.TARGET_CHANNELS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.market.mainCompetitors')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS)}
      >
        {/* 1.4.5 */}
        <TextInputControl
          multiline
          control={control}
          id="executiveSummary.market.mainCompetitors"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.MAIN_COMPETITORS)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1000}
        />
      </FormSectionCard>
    </>
  );
};
